module.exports = __webpack_public_path__ + "static/media/default-profile.e4833d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/crop/default-profile.png
// module id = 2134
// module chunks = 0